import * as Auth from '../services/auth';
import * as Teacher from '../services/teacher';
import * as Employee from '../services/employee';
import * as Course from '../services/course';
import * as Claim from '../services/claim';
import * as Student from '../services/student';
import * as School from '../services/school';


export const AuthService = Auth;
export const TeacherService = Teacher;
export const CourseService = Course;
export const ClaimService = Claim;
export const EmployeeService = Employee;
export const StudentService = Student;
export const SchoolService = School;
